const ChurchIcon = () => (
  <svg viewBox="0 0 24 24" aria-hidden>
    <path d="M12 3 2 9v2h2v8h5v-6h6v6h5v-8h2V9L12 3zm0 2.8 6 4v1.2h-1v6h-3v-6H10v6H7v-6H6V9.8l6-4z" />
  </svg>
);

export const ChurchBrandMark = ({
  churchName,
  campusName,
  logoUrl,
  title,
  description,
}: {
  churchName: string;
  campusName?: string | null;
  logoUrl?: string | null;
  title?: string;
  description?: string | null;
}) => {
  const showCampus =
    campusName?.trim() &&
    campusName.toLocaleLowerCase() !== churchName.toLocaleLowerCase();

  return (
    <header className="church-brand">
      {logoUrl ? (
        <img src={logoUrl} alt="" className="church-brand-logo" />
      ) : (
        <div className="church-brand-logo-fallback" aria-hidden>
          <ChurchIcon />
        </div>
      )}
      <p className="church-brand-eyebrow">{churchName}</p>
      {showCampus ? <p className="church-brand-campus">{campusName}</p> : null}
      {title ? <h1 className="church-brand-title">{title}</h1> : null}
      {description?.trim() ? <p className="church-brand-description">{description}</p> : null}
    </header>
  );
};
